/**
 * Trả về tên hệ điều hành di động (ios, android) hoặc null nếu là desktop
 */
export const getMobileOS = (): 'ios' | 'android' | 'other' | null => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  // Kiểm tra iOS (iPhone, iPad, iPod)
  // Lưu ý: iPad chạy iPadOS 13+ có User Agent giống Mac, nên cần check thêm maxTouchPoints
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return 'ios';
  }

  // Kiểm tra iPad Pro chạy iPadOS (thường bị nhận nhầm là Mac)
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return 'ios';
  }

  // Kiểm tra Android
  if (/android/i.test(userAgent)) {
    return 'android';
  }

  // Kiểm tra các thiết bị di động khác (Windows Phone, v.v.)
  if (/Mobi|Tablet|Mobile|Opera Mini/i.test(userAgent)) {
    return 'other';
  }

  return null;
};

export const isIOS = () => getMobileOS() === 'ios';
export const isAndroid = () => getMobileOS() === 'android';
